// El error de la API de Nexo y cómo se arma desde una respuesta fallida o un aborto. Sin import.meta.env (eso queda en api.ts), para
// probarlo con Deno (app/scripts/nexo-ficha.test.ts): la ficha distingue los errores de la base por su código y una cancelación de la
// pantalla no debe verse como «tardó demasiado».

export class ApiError extends Error {
  /** El código de error de la base (PostgREST lo manda como `code`, p. ej. «P0002»), cuando lo hay. */
  readonly codigo: string | null;
  constructor(mensaje: string, readonly status?: number, codigo?: string | null) {
    super(mensaje);
    this.name = "ApiError";
    this.codigo = codigo ?? null;
  }
}

/** El error de una respuesta no exitosa: el mensaje del cuerpo (o el estado HTTP) y el código de la base. */
export function errorDeRespuesta(cuerpo: unknown, statusText: string, status: number): ApiError {
  let detalle = statusText;
  let codigo: string | null = null;
  if (cuerpo && typeof cuerpo === "object") {
    const c = cuerpo as Record<string, unknown>;
    const candidato = [c["message"], c["error_description"], c["error"], c["msg"]].find((x): x is string => typeof x === "string");
    if (candidato) detalle = candidato;
    if (typeof c["code"] === "string") codigo = c["code"];
  }
  return new ApiError(detalle, status, codigo);
}

/**
 * Lo que se lanza cuando fetch se aborta: si lo canceló la pantalla, la misma cancelación (no es un error que mostrar); si fue el reloj
 * de la petición, «tardó demasiado» con estado 408.
 */
export function errorDeAborto(e: unknown, canceladaPorPantalla: boolean): unknown {
  if (!(e instanceof DOMException && e.name === "AbortError")) return e;
  if (canceladaPorPantalla) return e;
  return new ApiError("La solicitud tardó demasiado. Revisa tu internet e inténtalo de nuevo.", 408);
}
